import { render, staticRenderFns } from "./DialogForCustomVip.vue?vue&type=template&id=0d03753f&scoped=true&"
import script from "./DialogForCustomVip.vue?vue&type=script&lang=js&"
export * from "./DialogForCustomVip.vue?vue&type=script&lang=js&"
import style0 from "./DialogForCustomVip.vue?vue&type=style&index=0&id=0d03753f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03753f",
  null
  
)

export default component.exports